// © 2026 Holmes Computer Consultants. All rights reserved.
import { BufferAttribute, BufferGeometry, Group, Mesh, type Material } from 'three'
import type asset from '../../SourceArt/PierRamps/mesh.json'
import type { Vec3 } from './tubePath'
import type { PartPalette, Finish } from './partsKit'

let data: typeof asset | undefined
/** Exact fitted assemblies shared by all stock tables. */
export async function prepareAuthoredRamps(): Promise<void> {
  data ??= (await import('../../SourceArt/PierRamps/mesh.json')).default
}

/** Fitted Blender assembly only when the current simulation is the authored curve. */
export function addAuthoredRamp(machineId: string, layerId: string, width: number, wallHeight: number,
  path: readonly Vec3[], group: Group, palette: PartPalette, geometries: BufferGeometry[], steel?:Material): boolean {
  const fitted = data?.ramps.find(r => r.machineId === machineId && r.layerId === layerId)
  if (!fitted || Math.abs(fitted.width - width) > 1e-8 || Math.abs(fitted.wallHeight - wallHeight) > 1e-8
    || path.length !== fitted.path.length) return false
  for (let i = 0; i < path.length; i++) for (let axis = 0; axis < 3; axis++)
    if (Math.abs(path[i]![axis]! - fitted.path[i]![axis]!) > 1e-6) return false
  for (const part of fitted.parts) {
    const geometry = new BufferGeometry()
    geometry.setAttribute('position', new BufferAttribute(new Float32Array(part.positions), 3))
    geometry.setAttribute('normal', new BufferAttribute(new Float32Array(part.normals), 3))
    geometry.setIndex(part.triangles); geometry.computeBoundingBox(); geometry.computeBoundingSphere()
    geometries.push(geometry)
    const finish = (part.finish[0]!.toLowerCase() + part.finish.slice(1)) as Finish
    const material=part.finish==='HardwareSteel'?(steel??palette.satinSpinnerSteel()):part.finish==='RampClearSheet'||part.finish==='RampClearEdge'?palette.acrylic(finish):palette.get(finish)
    const mesh = new Mesh(geometry, material); mesh.name = `${layerId}.authored.${part.finish}`
    group.add(mesh)
  }
  return true
}
